module.exports = __webpack_public_path__ + "img/low.edc1f66.svg";